import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		passengers: []
	},

	actions: {
		fetchAll({ commit }, { page, itemsPerPage, vehicleId, academicYear, specialtyId, courseId }) {
			return axios.get('/center/{centerId}/user/{username}/get-all-bus-students', {
				params: {
					pagingParameter: {
						pageNumber: page,
						pageSize: itemsPerPage,
					},
					
					filterRequest: {
						busId: vehicleId,
						academicYear,
						specialtyId,
						courseId,
					}
				}
			}).then(({ data }) => {
				commit(types.STORE_PASSENGERS, data ? data.Students : []);
				return data || {};
			})
		},

		fetchByVehicleId({ commit }, { vehicleId }) {
			return axios.get('/center/{centerId}/user/{username}/get-bus-students', {
				params: { busId: vehicleId }
			}).then(({ data }) => {
				return data;
			})
		},

		fetchQRCodeAll({ commit }, { vehicleId, academicYear, specialtyId, courseId }) {
			return axios.get('/center/{centerId}/user/{username}/generate-qr', {
				params: {
					filterRequest: {
						busId: vehicleId,
						academicYear,
						specialtyId,
						courseId,
					}
				}
			}).then(({ data }) => {
				return data;
			})
		},

		fetchPassengerMovements({ commit }, { id }) {
			return axios.get('/center/{centerId}/user/{username}/get-student-status', {
				params: { accountId: id }
			}).then(({ data }) => {
				return data;
			})
		},

		updateLocation({ commit }, { passengerId, point }) {
			return axios.post('/center/{centerId}/user/{username}/add-student-point', {
				AccountId: passengerId,
				Lat: point.lat,
				Lng: point.lng
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_PASSENGERS](state, passengers) {
			state.passengers = passengers;
		},
		[types.RESET](state) {
			state.passengers = [];
		}
	},

	getters: {
		getPassengerById: state => id => state.passengers.find(c => c.AccountId === id)	
	}
}